module.exports = __webpack_public_path__ + "static/media/as.9b64c590.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/as.svg
// module id = 2036
// module chunks = 0